// ========================================
// GALLERY PAGE - INSTRUCTIONS FOR BEGINNERS
// ========================================
//
// This file controls the Gallery page of the website.
//
// WHAT YOU CAN EDIT:
// 1. Image information (titles, descriptions, image paths)
// 2. Add new images or remove existing ones
// 3. Change the gallery title and subtitle
//
// WHAT NOT TO EDIT:
// - The import statements at the top
// - The useState and function code (unless you know what you're doing)
// - The return section structure (just the text content)
//
// HOW TO ADD A NEW IMAGE:
// 1. Find the images array below
// 2. Copy an existing image object (everything between { and })
// 3. Paste it in the images array
// 4. Change the id to a unique number
// 5. Update src, title, and description
//
// HOW TO CHANGE IMAGES:
// 1. Put your image files in the publicimages/ folder
// 2. Change the src path to "images/your-image-name.jpg"
//
// HOW TO CHANGE TITLES AND DESCRIPTIONS:
// - title: The text that appears when you hover over an image
// - description: The text that appears in the fullscreen view
//
// HOW TO CHANGE THE PAGE TITLE:
// - Look for "Game Gallery" text below and change it
// - Look for the subtitle text and change it

import React, { useState } from "react";
import "./index.css";

const Gallery = () => {
  // ========================================
  // GALLERY DATA - EDIT THIS SECTION TO UPDATE IMAGES
  // ========================================
  //
  // TO ADD A NEW IMAGE:
  // 1. Add a new object to the images array below
  // 2. Give it a unique id (like 13, 14, 15, etc.)
  // 3. Set the src to the image path (put images in publicimages/ folder)
  // 4. Add a title and description
  //
  // TO EDIT EXISTING IMAGES:
  // - src: The image path (put images in publicimages/ folder)
  // - title: The image title that appears on hover
  // - description: The description that appears in the fullscreen view

  const images = [
    {
      id: 1,
  src: "/images/DDay.jpeg",
      title: "Double Trouble",
      description: "omnomhombrger",
    },
    {
      id: 2,
  src: "/images/OnTheWay.png",
      title: "On The Way!",
      description: "omnomhombrger",
    },
    {
      id: 3,
  src: "/images/TTS.jpeg",
      title: "Through The Smoke",
      description: "omnomhombrger",
    },
    {
      id: 4,
  src: "/images/hlltank.jpg",
      title: "Jumboooo",
      description: "alexinfinit_503",
    },
    {
      id: 5,
  src: "/images/5thinf.png",
      title: "What A Lovely Vie-",
      description: "omnomhombrger",
    },
    {
      id: 6,
  src: "/images/byebyebtr.JPG",
      title: "Bye Bye BTR!!",
      description: "huolibuzukongju",
    },
    {
      id: 7,
  src: "/images/hdii1.JPG",
      title: "Rather Ominous...",
      description: "justatacticalgatto",
    }, 
    {
      id: 8,
  src: "/images/hdii2.JPG",
      title: "Lazerrr",
      description: "alysius",
    },
    {
      id: 9,
  src: "/images/hdii3.JPG",
      title: "Attentttttion!",
      description: "phx0403",
    },
    {
      id: 10,
  src: "/images/heli.JPG",
      title: "Heliboptrr",
      description: "huolibuzukongju",
    },
    {
      id: 11,
  src: "/images/helo2.png",
      title: "Hello There!",
      description: "huolibuzukongju",
    },
    {
      id: 12,
  src: "/images/t34.png",
      title: "Soviet Steel",
      description: "onnomhombrger",
    },
    {
      id: 13,
  src: "/images/tankplatoon.png",
      title: "Rolling Up Al Basrah",
      description: "frozy_idk",
    },
    {
      id: 14,
  src: "/images/tankplatoon2.png",
      title: "Rolling Up Al Basrah, Alone This Time",
      description: "frozy_idk",
    },
    {
      id: 15,
  src: "/images/tiger.png",
      title: "German Steel",
      description: "omnomhombrger",
    },
    {
      id: 16,
  src: "/images/dedtank.png",
      title: "Thats A Lot Of Scrap",
      description: "ripper_sa1nt",
    },
     {
      id: 17,
  src: "/images/hll.png",
      title: "Sherman Sunset",
      description: "omnomhombrger",
    },
     {
      id: 18,
  src: "/images/bfv2.jpg",
      title: "Kaboom? Yes Rico, Kaboom",
      description: "omnomhombrger",
    },
     {
      id: 19,
  src: "/images/bfv1.jpg",
      title: "What A Lovely Hill...",
      description: "omnomhombrger ",
    },
    {
      id: 20,
  src: "/images/sunset.png",
      title: "After A Long Day Of Pirating",
      description: "omnomhombrger",
    },
    {
      id: 21,
  src: "/images/sot.png",
      title: "Step 1 - Diagnose The Problem",
      description: "omnomhombrger",
    },
    {
      id: 22,
  src: "/images/sot1.png",
      title: "Blub Blub Blub",
      description: "omnomhombrger",
    },
    {
      id: 23,
  src: "/images/ztzsabot.png",
      title: "ZTZ Is About To Go Bang",
      description: "omnomhombrger",
    },
    {
      id: 24,
  src: "/images/ztzboom.png",
      title: "ZTZ Go Bang",
      description: "omnomhombrger",
    },
    {
      id: 25,
  src: "/images/ztzsmoke.png",
      title: "Is That A Tank?",
      description: "omnomhombrger",
    },
    {
      id: 26,
  src: "/images/ztzturretturn.png",
      title: "Victory At Last",
      description: "omnomhombrger",
    },
    {
      id: 27,
  src: "/images/stinky.png",
      title: "Stinky Situations",
      description: "omnomhombrger",
    },
    {
      id: 28,
  src: "/images/bmp.png",
      title: "BMP In The Desert",
      description: "omnomhombrger",
    },
    {
      id: 29,
  src: "/images/crappilot.png",
      title: "Wesley Cant Fly",
      description: "omnomhombrger",
    },
    {
      id: 30,
  src: "/images/gradfromair.png",
      title: "Try Not To Get Hit",
      description: "omnomhombrger",
    },
    {
      id: 31,
  src: "/images/gradontalil.png",
      title: "Bombardment From Above",
      description: "omnomhombrger",
    },
    {
      id: 32,
  src: "/images/helionsax.png",
      title: "Helicopter Helicopter",
      description: "omnomhombrger",
    },
    {
      id: 33,
  src: "/images/jhook.png",
      title: "It Didnt Go Well After This",
      description: "omnomhombrger",
    },
  ];

  // ========================================
  // FULLSCREEN FUNCTIONALITY - DON'T EDIT THIS SECTION
  // ========================================
  // This code handles opening and closing the fullscreen image view
  // You don't need to change anything here unless you want to add new features

  // State for fullscreen overlay
  const [selectedImage, setSelectedImage] = useState(null);

  // Function to open fullscreen view
  const openFullscreen = (image) => {
    setSelectedImage(image);
  };

  // Function to close fullscreen view
  const closeFullscreen = () => {
    setSelectedImage(null);
  };

  // Function to handle escape key
  const handleKeyDown = (e) => {
    if (e.key === "Escape") {
      closeFullscreen();
    }
  };

  // ========================================
  // PAGE LAYOUT - EDIT TITLES AND TEXT HERE
  // ========================================
  // This section controls how the page looks and what text appears
  //
  // TO CHANGE THE PAGE TITLE:
  // - Change "Game Gallery" to whatever you want
  //
  // TO CHANGE THE SUBTITLE:
  // - Change "Explore our supported games and community highlights" to whatever you want
  //
  // TO ADD A NEW SECTION:
  // - You can add more text or sections before the masonry-grid div

  return (
    <div className="gallery-page">
      <div className="gallery-container">
        <h1 className="gallery-title">Gallery - Media By Our Community</h1> {/* CHANGE THIS TEXT */}
        {/* ======================================== */}
        {/* MASONRY GRID - DON'T EDIT THIS SECTION */}
        {/* ======================================== */}
        {/* This creates the grid layout and handles clicking on images */}
        {/* The images come from the images array above */}
        {/* You don't need to change anything here */}
        <div className="masonry-grid">
          {images.map((image) => (
            <div
              key={image.id}
              className="masonry-item"
              onClick={() => openFullscreen(image)}
            >
              <img
                src={image.src}
                alt={image.title}
                className="gallery-image"
              />
              <div className="image-overlay">
                <h3 className="image-title">{image.title}</h3>
              </div>
            </div>
          ))}
        </div>
        {/* ======================================== */}
        {/* FULLSCREEN OVERLAY - DON'T EDIT THIS SECTION */}
        {/* ======================================== */}
        {/* This creates the fullscreen image view when you click an image */}
        {/* It shows the image title and description */}
        {/* You don't need to change anything here */}
        {selectedImage && (
          <div
            className="fullscreen-overlay"
            onClick={closeFullscreen}
            onKeyDown={handleKeyDown}
            tabIndex={0}
          >
            <div
              className="fullscreen-content"
              onClick={(e) => e.stopPropagation()}
            >
              <button
                className="close-button"
                onClick={closeFullscreen}
                aria-label="Close image"
              >
                ×
              </button>
              <img
                src={selectedImage.src}
                alt={selectedImage.title}
                className="fullscreen-image"
              />
              <div className="fullscreen-info">
                <h2 className="fullscreen-title">{selectedImage.title}</h2>
                <p className="fullscreen-description">
                  {selectedImage.description}
                </p>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default Gallery;
